var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "j-modal",
    {
      staticStyle: { top: "5%", height: "85%", "overflow-y": "hidden" },
      attrs: {
        title: _vm.title,
        width: 800,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading,
        maskClosable: false,
        okText: this.$store.getters.language["common.okButton"],
        cancelText: _vm.language["common.closeButton"],
        wrapClassName: "ant-modal-cust-warp"
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel }
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form-model",
            _vm._b(
              {
                ref: "form",
                attrs: { model: _vm.model, rules: _vm.validatorRules }
              },
              "a-form-model",
              _vm.layout,
              false
            ),
            [
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    prop: "applicationId",
                    label: _vm.language["premission.applicationName"]
                  }
                },
                [
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        allowClear: "",
                        placeholder: _vm.language["premission.mustApplication"],
                        disabled:
                          _vm.$store.getters.application.applicationType !==
                          "platform"
                      },
                      model: {
                        value: _vm.model.applicationId,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "applicationId", $$v)
                        },
                        expression: "model.applicationId"
                      }
                    },
                    _vm._l(_vm.application, function(item, index) {
                      return _c(
                        "a-select-option",
                        { key: index.toString(), attrs: { value: item.id } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.applicationNameLanguage) +
                              "\n          "
                          )
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["platform.roleUser.columns.roleCode"],
                    required: "",
                    prop: "roleCode"
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      disabled: _vm.roleDisabled,
                      placeholder:
                        _vm.language[
                          "platform.roleUser.columns.pleaseSetRoleCode"
                        ]
                    },
                    model: {
                      value: _vm.model.roleCode,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "roleCode", $$v)
                      },
                      expression: "model.roleCode"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["platform.roleUser.columns.roleName"],
                    required: "",
                    prop: "roleName"
                  }
                },
                [
                  _c("a-input", {
                    staticStyle: { width: "80%" },
                    attrs: {
                      placeholder:
                        _vm.language[
                          "platform.roleUser.columns.pleaseSetRolename"
                        ]
                    },
                    model: {
                      value: _vm.model.roleName,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "roleName", $$v)
                      },
                      expression: "model.roleName"
                    }
                  }),
                  _c(
                    "a-button",
                    {
                      staticStyle: { left: "3%" },
                      attrs: { type: "primary" },
                      on: { click: _vm.roleNameLanguageOpen }
                    },
                    [_vm._v(_vm._s(_vm.language["common.language"]))]
                  )
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["common.desc"],
                    prop: "description"
                  }
                },
                [
                  _c("a-textarea", {
                    attrs: {
                      rows: 5,
                      placeholder:
                        _vm.language[
                          "platform.roleUser.columns.pleaseSetRoleDescription"
                        ]
                    },
                    model: {
                      value: _vm.model.description,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "description", $$v)
                      },
                      expression: "model.description"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("language-model", {
            ref: "languageModel",
            on: { ok: _vm.languageOk }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }